import React, { Component } from 'react'
import styled from 'react-emotion'
import BookingOverview from '../../booking'
import { Container } from '../../styles'

const Wrapper = styled('div')`
  @media (max-width: 767px) {
    margin-left: 15px;
    margin-right: 15px;
  }
`
const Section = styled('section')`
  margin-bottom: 20px;
  h2 {
    margin-bottom: 10px;
    @media (max-width: 992px) {
      margin-bottom: 10px;
    }
  }
`

export default class Overview extends Component {
  constructor(props) {
    super(props)

    this.state = {
      bookingsLoading: true,
      hasBookings: false,
    }
  }

  handleBookingsLoaded = (hasBookings) => {
    this.setState({ bookingsLoading: false, hasBookings })
  }

  render() {
    return (
      <Wrapper>
        <Section>
          <Container>
            <BookingOverview onBookingsLoaded={this.handleBookingsLoaded} />
          </Container>
        </Section>
      </Wrapper>
    )
  }
}
